import React from 'react';
import { motion } from 'framer-motion';
import { CircleDollarSign, Ban, HandCoins } from 'lucide-react';
const pledges = [{
  icon: Ban,
  label: 'No Corporate PACs',
  detail: 'Zero dollars from corporate political action committees.'
}, {
  icon: CircleDollarSign,
  label: 'No AIPAC Money',
  detail: 'Rejecting influence from the AIPAC lobby.'
}, {
  icon: HandCoins,
  label: 'No Crypto Cash',
  detail: 'No cryptocurrency industry donations.'
}];
export function PeoplePowered() {
  return <section className="py-20 md:py-28 bg-white relative overflow-hidden" data-id="element-168">
      {/* Subtle texture */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" data-id="element-169">
        <div className="absolute inset-0" style={{
        backgroundImage: 'repeating-linear-gradient(45deg, #0A192F 0, #0A192F 1px, transparent 0, transparent 50%)',
        backgroundSize: '12px 12px'
      }} data-id="element-170" />
      </div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="text-center mb-14" data-id="element-172">
          <span className="inline-block bg-red text-white font-bold tracking-widest uppercase text-xs px-5 py-2 rounded-sm mb-6" data-id="element-173">
            My Pledge to You
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-navy leading-tight mb-6" data-id="element-174">
            100% People-Powered.{' '}
            <span className="italic text-red" data-id="element-175">Not a dime</span> from
            <br className="hidden md:block" data-id="element-176" />{' '}
            <span className="relative inline-block pb-2" data-id="element-177">
              Corporate PACs, AIPAC, or Crypto.
              <span className="absolute left-0 right-0 bottom-0 h-[4px] bg-sky/80 rounded-full" data-id="element-178" />
            </span>
          </h2>
          <p className="text-navy/70 text-lg md:text-xl font-light max-w-2xl mx-auto leading-relaxed" data-id="element-179">
            Elizabeth answers to working families — not lobbyists, not special
            interests, not billionaire donors. This campaign is funded entirely
            by people like you.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 mb-14" data-id="element-180">
          {pledges.map((pledge, index) => <motion.div key={pledge.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.12
        }} className="bg-warmgray border border-navy/10 rounded-sm p-8 text-center" data-id="element-181">
              <div className="w-16 h-16 bg-red/10 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-182">
                <pledge.icon className="text-red" size={28} strokeWidth={1.5} data-id="element-183" />
              </div>
              <h3 className="text-navy font-bold tracking-widest uppercase text-sm mb-2" data-id="element-184">
                {pledge.label}
              </h3>
              <p className="text-navy/60 font-light text-sm" data-id="element-185">{pledge.detail}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-186">
          <a href="https://secure.actblue.com/donate/guzman_va_web" target="_blank" rel="noopener noreferrer" className="inline-block bg-red hover:bg-navy text-white font-bold text-sm tracking-widest uppercase px-10 py-4 rounded-sm transition-colors shadow-lg" data-id="element-187">
            Chip In — Fund This People Powered Campaign
          </a>
        </motion.div>
      </div>
    </section>;
}